import axios from "axios";
import { getCookie } from "../../getcookie";
const apiUrl = process.env.REACT_APP_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getVehiclesListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `vehicle`, {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const submitVehicleAPI = async (body) => {
  try {
    const response = await axios.post(apiUrl + `vehicle`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateVehicleAPI = async (id, body) => {
  try {
    const response = await axios.put(apiUrl + `vehicle/` + id, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getVehicleEditApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `vehicle/get/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const deleteVehicleApi = async (id) => {
  try {
    const response = await axios.delete(apiUrl + `vehicle/delete/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const bulkDeleteVehicleApi = async (payload) => {
  try {
    const data = Array.isArray(payload) ? { id: payload } : payload;
    const response = await axios.delete(apiUrl + `vehicle/bulkdelete`, {
      data,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const saveAttachmentApi = async (id, body) => {
  try {
    const response = await axios.put(apiUrl + `vehicle/attachment/` + id, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const submitVehicleFuelEntry = async (body) => {
  try {
    const response = await axios.post(apiUrl + `vehicle/fuel_entry`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const submitVehicleKMEntry = async (body) => {
  try {
    const response = await axios.post(apiUrl + `vehicle/km_entry`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const getVehicleViewApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `vehicle/get/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const updateStatusApi = async (id, bodyData) => {
  try {
    const response = await axios.put(apiUrl + `vehicle/status_update/` + id, bodyData, {
      headers: header,
    });
    console.log("response..", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response?.data ?? { success: false, message: err.message };
  } finally {
  }
};

export const getFuelEntryApi = async (id, params) => {
  try {
    const response = await axios.get(apiUrl + `vehicle/fuel_entry/` + id, {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getKMEntryApi = async (id, params) => {
  try {
    const response = await axios.get(apiUrl + `vehicle/km_entry/` + id, {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const saveFuelAttachmentApi = async (id, body) => {
  try {
    const response = await axios.put(apiUrl + `vehicle/fuel_entry/attachment/` + id, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const saveKMAttachmentApi = async (id, body) => {
  try {
    const response = await axios.put(apiUrl + `vehicle/km_entry/attachment/` + id, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
